import React, { Fragment, useState } from 'react';
import { connect } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import * as actions_dashboard from "redux/actions/dashboardActions";
import { Translate, I18n } from "react-redux-i18n";
import InputDate from 'components/InputDate';
import { element } from 'prop-types';

function counterRoll(reference) {

    if (reference.indexOf('Roll') >= 0) {
        var text = reference.substring(0, reference.indexOf('Roll'));
        var sec = reference.substring(reference.indexOf('Roll') + 4, reference.length);
        sec = parseInt(sec) + 1;
        return text + "Roll" + sec;
    }
    return reference + "Roll1";
}

function getCloseAt(expire_at) {
    if (expire_at && new Date(expire_at) < new Date())
        return new Date(expire_at).toISOString().split('T')[0];

    return new Date().toISOString().split('T')[0];
}

const FormDialog = (props) => {
    const { item, ...rest } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        setValues({
            symbol: item.symbol,
            quantity: item.quantity,
            close_price: props.price || Math.abs(item.close_price) || 0.01,
            open_price: Math.abs(item.open_price) || 0.01,
            strike: item.strike,
            strike_temp: item.strike,
            //close_at: new Date().toISOString().split('T')[0],
            open_at: new Date().toISOString().split('T')[0],
            expire_at: new Date(props.item.expire_at).toISOString().split('T')[0],
            close_at: getCloseAt(props.item.expire_at),// 
            market: item.market,
            option_kind: item.option_kind,
            option_id: item.id,
            reference: counterRoll(item.reference || ""),
            id: props.user_id
        });
        if (item.sub_order.length > 1) {
            setStrategy({
                ...strategy,
                leg: item.sub_order,
                symbol: item.sub_order.length > 1 && item.sub_order[0].symbol,
            });
        }
    };

    const handleClose = () => {
        setOpen(false);
        if (typeof props.close === 'function') {
            props.close();
        }
    };

    const handleSave = () => {
        if (item.sub_order.length > 1)
            props.rollStrategy({
                ...strategy,
                close_at: values.close_at,
                open_at: values.open_at,
                reference: values.reference,
                expire_at: values.expire_at
            }, props.token);
        else
            props.rollItem(values, props.token);

        props.loadListIndicator(props.user_id, props.token);
        handleClose();
    };

    const handleSaveShare = (event) => {
        if (item.sub_order.length > 1)
            props.rollStrategy({
                ...strategy,
                share: true,
                close_at: values.close_at,
                open_at: values.open_at,
            }, props.token);
        else
            props.rollItem({
                ...values,
                share: true,
            }, props.token);

        props.loadListIndicator(props.user_id, props.token);
        handleClose();

    };

    const [values, setValues] = useState({
        symbol: item.symbol,
        quantity: item.quantity,
        close_price: props.price || Math.abs(item.close_price) || 0.01,
        open_price: Math.abs(item.open_price) || 0.01,
        strike: item.strike,
        strike_temp: item.strike,
        //close_at: new Date().toISOString().split('T')[0],
        open_at: new Date().toISOString().split('T')[0],
        expire_at: new Date(props.item.expire_at).toISOString().split('T')[0],
        close_at: getCloseAt(props.item.expire_at),// 
        market: item.market,
        option_kind: item.option_kind,
        option_id: item.id,
        reference: counterRoll(item.reference || ""),
        id: props.user_id
    });

    const [strategy, setStrategy] = useState({
        symbol: item.sub_order.length > 1 && item.sub_order[0].symbol,
        name: "",
        id: props.user_id,
        share: false,
        leg: item.sub_order,
        close_at: "",
        open_at: "",
    });


    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value,
        });
    };

    const option_kind = [
        {
            value: "CALL",
            label: "Call",
        },
        {
            value: "PUT",
            label: "Put",
        },
    ];

    const option_market_open = [
        {
            value: "SELL",
            label: "STO",
        },
        {
            value: "BUY",
            label: "BTO",
        },
    ];
    const option_market_close = [
        {
            value: "SELL",
            label: "STC",
        },
        {
            value: "BUY",
            label: "BTC",
        },
    ];

    const handleChangeLeg = (i, e) => {
        let leg = strategy.leg;
        if (!leg[i].strike_temp)
            leg[i].strike_temp = props.item.sub_order[i].strike;
        leg[i][e.target.name] = e.target.value;
        setStrategy(strategy => ({
            ...strategy,
            leg: leg
        }));
    }

    return (
        // <div style={{ "display": "inline" }}>
        //     <button 
        //         className='btn btn-primary btn-sm' 
        //         onClick={handleClickOpen}>
        //         Roll
        //     </button>
        //     {open && (
                <div className='dialog'>              
                <div className='dialog-content' style={{ "max-width": "700px" }}>
                    <div className='dialog-title'> Option Roll  {item.symbol}</div>
                    <div className='dialog-content-text'>
                        Enter Data Option Roll
                    </div>
                    {
                        (item.sub_order.length > 1) ?
                            (
                                strategy.leg.map((element, index) => (
                                    <React.Fragment>
                                        <div className="entry-form-grid entry-form-grid--4">
                                            <div className="entry-field">
                                                <label htmlFor={`close_quantity_${index}`}>Quantity</label>
                                                <input
                                                    id={`close_quantity_${index}`}
                                                    name="quantity"
                                                    required="true"
                                                    type="number"
                                                    min="1"
                                                    value={element.quantity}
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                />
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`close_market_${index}`}>Close kind</label>
                                                <select
                                                    id={`close_market_${index}`}
                                                    name="market"
                                                    required="true"
                                                    type="text"
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                    value={(element.market === "SELL" ? "BUY" : "SELL")}
                                                >
                                                    <option key={"0"} value={"0"}>
                                                        {"STC/BTC"}
                                                    </option>
                                                    {option_market_close.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`close_option_kind_${index}`}>Option kind</label>
                                                <select
                                                    id={`close_option_kind_${index}`}
                                                    name="option_kind"
                                                    required="true"
                                                    type="text"
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                    value={element.option_kind}
                                                >
                                                    <option key={"0"} value={"0"}>
                                                        {"Call/Put"}
                                                    </option>
                                                    {option_kind.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`close_strike_temp_${index}`}>Close strike</label>
                                                <input
                                                    id={`close_strike_temp_${index}`}
                                                    name="strike_temp"
                                                    required="true"
                                                    type="number"
                                                    min="0.01"
                                                    step="0.01"
                                                    inputProps={{
                                                        step: 0.1,
                                                    }}
                                                    value={element.strike_temp || element.strike}
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="entry-form-grid entry-form-grid--4">
                                            <div className="entry-field">
                                                <label htmlFor={`open_quantity_${index}`}>Quantity</label>
                                                <input
                                                    id={`open_quantity_${index}`}
                                                    name="quantity"
                                                    required="true"
                                                    type="number"
                                                    min="1"
                                                    value={element.quantity}
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                />
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`open_market_${index}`}>Open kind</label>
                                                <select
                                                    id={`open_market_${index}`}
                                                    name="market"
                                                    required="true"
                                                    type="text"
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                    value={element.market}
                                                >
                                                    <option key={"0"} value={"0"}>
                                                        {"STO/BTO"}
                                                    </option>
                                                    {option_market_open.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`open_option_kind_${index}`}>Option kind</label>
                                                <select
                                                    id={`open_option_kind_${index}`}
                                                    name="option_kind"
                                                    required="true"
                                                    type="text"
                                                    onChange={e => handleChangeLeg(index, e)}
                                                    disabled
                                                    value={element.option_kind}
                                                >
                                                    <option key={"0"} value={"0"}>
                                                        {"Call/Put"}
                                                    </option>
                                                    {option_kind.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`open_strike_${index}`}>Open strike</label>
                                                <input
                                                    id={`open_strike_${index}`}
                                                    name="strike"
                                                    required="true"
                                                    type="number"
                                                    min="0.01"
                                                    step="0.01"
                                                    inputProps={{
                                                        step: 0.1,
                                                    }}
                                                    value={element.strike}
                                                    onChange={e => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                        </div>
                                        <div className="entry-form-grid entry-form-grid--3">
                                            <div className="entry-field">
                                                <label htmlFor={`close_price_${index}`}>Close price</label>
                                                <input
                                                    autoFocus
                                                    id={`close_price_${index}`}
                                                    name="close_price"
                                                    type="number"
                                                    min="0.01"
                                                    step="0.01"
                                                    inputProps={{
                                                        step: 0.01,
                                                    }}
                                                    value={element.close_price || Math.abs(element.open_price)}
                                                    onChange={e => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`open_price_${index}`}>Prmn/Debit</label>
                                                <input
                                                    id={`open_price_${index}`}
                                                    name="open_price"
                                                    required="true"
                                                    type="number"
                                                    min="0.01"
                                                    step="0.01"
                                                    inputProps={{
                                                        step: 0.01,
                                                    }}
                                                    value={Math.abs(element.open_price)}
                                                    onChange={e => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                        </div>
                                    </React.Fragment>))) :
                            (
                                <React.Fragment>
                                    <div className="entry-form-grid entry-form-grid--4">
                                        <div className="entry-field">
                                            <label htmlFor="close_quantity">Quantity</label>
                                            <input
                                                id="close_quantity"
                                                name="quantity"
                                                required="true"
                                                type="number"
                                                min="1"
                                                value={values.quantity}
                                                onChange={handleChange}
                                                disabled
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="close_market">Close kind</label>
                                            <select
                                                id="close_market"
                                                name="market"
                                                required="true"
                                                type="text"
                                                onChange={handleChange}
                                                disabled
                                                value={(item.market === "SELL" ? "BUY" : "SELL")}
                                            >
                                                <option key={"0"} value={"0"}>
                                                    {"STC/BTC"}
                                                </option>
                                                {option_market_close.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="close_option_kind">Option kind</label>
                                            <select
                                                id="close_option_kind"
                                                name="option_kind"
                                                required="true"
                                                type="text"
                                                onChange={handleChange}
                                                disabled
                                                value={values.option_kind}
                                            >
                                                <option key={"0"} value={"0"}>
                                                    {"Call/Put"}
                                                </option>
                                                {option_kind.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="close_strike_temp">Close strike</label>
                                            <input
                                                id="close_strike_temp"
                                                name="strike_temp"
                                                required="true"
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                inputProps={{
                                                    step: 0.1,
                                                }}
                                                value={values.strike_temp}
                                                onChange={handleChange}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="entry-form-grid entry-form-grid--4">
                                        <div className="entry-field">
                                            <label htmlFor="open_quantity">Quantity</label>
                                            <input
                                                id="open_quantity"
                                                name="quantity"
                                                required="true"
                                                type="number"
                                                min="1"
                                                value={values.quantity}
                                                onChange={handleChange}
                                                disabled
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="open_market">Open kind</label>
                                            <select
                                                id="open_market"
                                                name="market"
                                                required="true"
                                                type="text"
                                                onChange={handleChange}
                                                disabled
                                                value={item.market}
                                            >
                                                <option key={"0"} value={"0"}>
                                                    {"STO/BTO"}
                                                </option>
                                                {option_market_open.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="open_option_kind">Option kind</label>
                                            <select
                                                id="open_option_kind"
                                                name="option_kind"
                                                required="true"
                                                type="text"
                                                onChange={handleChange}
                                                disabled
                                                value={values.option_kind}
                                           >
                                                <option key={"0"} value={"0"}>
                                                    {"Call/Put"}
                                                </option>
                                                {option_kind.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="open_strike">Open strike</label>
                                            <input
                                                id="open_strike"
                                                name="strike"
                                                required="true"
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                inputProps={{
                                                    step: 0.1,
                                                }}
                                                value={values.strike}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="entry-form-grid entry-form-grid--3">
                                        <div className="entry-field">
                                            <label htmlFor="close_price">Close price</label>
                                            <input
                                                autoFocus
                                                id="close_price"
                                                name="close_price"
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                inputProps={{
                                                    step: 0.01,
                                                }}
                                                value={values.close_price}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="entry-field">
                                            <label htmlFor="open_price">Prmn/Debit</label>
                                            <input
                                                id="open_price"
                                                name="open_price"
                                                required="true"
                                                type="number"
                                                min="0.01"
                                                step="0.01"
                                                inputProps={{
                                                    step: 0.01,
                                                }}
                                                value={values.open_price}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </React.Fragment>
                            )
                    }
                    < div style={{ "flexDirection": "row", "display": "flex", "justifyContent": "space-between" }}>
                        <inputDate
                            id="open_at"
                            name="open_at"
                            required="true"
                            placeHolder={"Roll At"}
                            label="Roll At(dd/mm/yyyy)"
                            value={values.open_at}
                            onChange={handleChange}
                            variant="lined"
                            min="1900-01-01"
                            max={new Date().toISOString().split('T')[0]}
                            disabled={false}
                        />

                        <inputDate
                            margin="dense"
                            id="expire_at"
                            name="expire_at"
                            required="true"
                            label="Expire At(dd/mm/yyyy)"
                            type="date"
                            value={values.expire_at}
                            onChange={handleChange}
                            variant="standard"
                            sx={{ m: 1, width: '14ch' }}
                        />
                    </div>
                
                    <div className='dialog-actions'>
                        <button 
                            className='btn btn-secondary'
                            onClick={handleClose}>
                            <Translate value="cancel" />
                        </button>
                        <button 
                            className='btn btn-primary' 
                            onClick={handleSaveShare}>
                            <Translate value="save_share" />
                        </button>
                        <button 
                            className='btn btn-primary' 
                            onClick={handleSave}>
                            <Translate value="save" />
                        </button>
                    </div>
                </div>
            </div>
        //         )}
        // </div >
    );
}

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

    };
}
const mapDispatchToProps = dispatch => ({
    rollItem: (params, token) =>
        dispatch(actions.rollItem({ params, token })),
    rollStrategy: (params, token) =>
        dispatch(actions.rollStrategy({ params, token })),
    ////////////////////////////////
    loadListIndicator: (user_id, token) =>
        dispatch(actions_dashboard.loadListIndicator({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);
/**
 *  
 */